import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmStatus } from '../interfaces/IKnmStatus';

export async function fetchKnmStatuses(isErknm?: boolean, isPm?: boolean): Promise<IKnmStatus[]> {
  const queryParams = new URLSearchParams();

  typeof isErknm === 'boolean' && queryParams.append('isFederalLaw248', isErknm.toString());
  typeof isPm === 'boolean' && queryParams.append('isPm', isPm.toString());

  return apiGet<IKnmStatus[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE, !isErknm)}/catalogs/knm-statuses?${queryParams}`,
  );
}

export async function fetchKnmDecisionStatuses(): Promise<IKnmStatus[]> {
  return apiGet<IKnmStatus[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/decision-passport-statuses`);
}
